import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from './NavLinks';

import useOmeMeetData from '../../state/omeMeet/UseOmeMeetData';
import useOmeMeetEntryData from '../../state/omeMeetEntry/UseOmeMeetEntryData';
import useOmeMeetOrgUnitEntryData from '../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useMeetCompetitionSummaryData from '../../state/meetCompetitionSummary/UseMeetCompetitionSummaryData';

import useMeetData from '@usas/ui-web/state/meet/UseMeetData';
import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import usePersonOrgRoleData from '@usas/ui-web/state/personOrgRole/UsePersonOrgRoleData';
import useOmeMeetAthleteEntryData from '../../state/omeMeetAthleteEntry/UseOmeMeetAthleteEntryData';
import useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData from '../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData';
import useOmeMeetTeamEntryData from '../../state/omeMeetTeamEntry/UseOmeMeetTeamEntryData';
import useMeetStaffData from '@usas/ui-web/state/meet/meetStaff/UseMeetStaffData';

const BACK_TO_LABELS = {
  meetBackToLabel: 'Back to Meet Search',
};

const useMeetContextView = () => {
  const navigate = useNavigate();
  const { meetState, meetFiltersState, clearObjData } = useMeetData();
  const { meetCompetitionSummaryState, clearMeetCompetitionSummaryObjData } = useMeetCompetitionSummaryData();
  const { clearOmeMeetObjData, clearOmeMeetArrayData } = useOmeMeetData();
  const { clearOmeMeetEntryObjData } = useOmeMeetEntryData();
  const { searchMeetState } = useSearchMeetData();
  const { clearOmeMeetOrgUnitEntryObjData, clearOmeMeetOrgUnitEntryArrayData } = useOmeMeetOrgUnitEntryData();
  const { clearArrayData } = usePersonOrgRoleData();
  const { clearOmeMeetAthleteEntryArrayData } = useOmeMeetAthleteEntryData();
  const { resetOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData } = useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
  const { resetOmeMeetTeamEntryState } = useOmeMeetTeamEntryData();
  const { resetMeetStaffState } = useMeetStaffData();

  const onHomeClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    navigate(NavLinks.MEET_INFO);
  };

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    switch ((meetFiltersState.backToSystem || '').toLowerCase()) {
      default:
        goToMeetSearch();
        break;
    }
  };

  function goToMeetSearch() {
    clearObjData();
    clearOmeMeetObjData();
    clearOmeMeetEntryObjData();
    clearOmeMeetOrgUnitEntryObjData();
    clearOmeMeetOrgUnitEntryArrayData();
    clearOmeMeetArrayData();
    resetOmeMeetTeamEntryState();
    clearArrayData();
    clearOmeMeetAthleteEntryArrayData();
    resetOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
    resetMeetStaffState();
    clearMeetCompetitionSummaryObjData();

      navigate(NavLinks.MEET_SEARCH);
  }

  function getBackToLabel() {
    return BACK_TO_LABELS[`${(meetFiltersState.backToSystem || '').toLowerCase()}BackToLabel`] || BACK_TO_LABELS.meetBackToLabel;
  }

  return {
    meetState,
    searchMeetState,
    meetCompetitionSummaryState,
    backToLabel: getBackToLabel(),
    onBackClicked,
    onHomeClicked
  };
};

export default useMeetContextView;